import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';

export const EmbeddedWebExperiencePage = wrapNavigatorScreen(
  () => {
    return null;
  },
  {
    headerShown: false,
  },
);
